import { bootstrap } from '@/utils/vuex'

const MUTATION_SET_OPENED = 'SET_OPENED'
const MUTATION_SET_URL = 'SET_URL'
const MUTATION_SET_TYPE = 'SET_TYPE'
const MUTATION_SET_TITLE = 'SET_TITLE'
const MUTATION_SET_URLS = 'SET_URLS'
const MUTATION_SET_SUBFORM = 'SET_SUBFORM'
const MUTATION_SET_SUBFORM_TEMP_DATA = 'SET_SUBFORM_TEMP_DATA'
const MUTATION_SET_CREATE_NEW_ELEMENT = 'SET_NEW_ELEMENT'
const MUTATION_SET_ROUTED_URL = 'SET_ROUTED_URL'
const MUTATION_SET_FORM_VIEW_ACTIVE = 'SET_FORM_VIEW_ACTIVE'

const MUTATION_POP_POPUPS = 'MUTATION_POP_POPUPS'

const STATE_POPUPS = 'popups'
const STATE_IS_OPENED = 'isOpened'
const STATE_URL = 'url'
const STATE_URLS = 'urls'
const STATE_TYPE = 'type'
const STATE_TITLE = 'title'
const STATE_SUBFORM = 'subForm'
const STATE_SUBFORM_TEMP_DATA = 'subFormTempData'
const STATE_CREATE_NEW_ELEMENT = 'createNewElement'
const STATE_ROUTED_URL = 'routedUrl'
const STATE_EVENT = 'event'

const lastPopup = (state) => state[STATE_POPUPS][[state[STATE_POPUPS].length - 1]] || {}
const updatePopup = (state, payload) => {
  state[STATE_POPUPS].splice(state[STATE_POPUPS].length - 1, 1, {
    ...lastPopup(state),
    ...payload,
  })
}

export const states = {
  STATE_IS_OPENED,
  STATE_URL,
  STATE_URLS,
  STATE_TYPE,
  STATE_TITLE,
  STATE_SUBFORM,
  STATE_SUBFORM_TEMP_DATA,
  STATE_CREATE_NEW_ELEMENT,
  STATE_ROUTED_URL,
  STATE_EVENT,
}

const state = function () {
  return {
    [STATE_POPUPS]: [],
    [STATE_ROUTED_URL]: null,
    /* [STATE_IS_OPENED]: false,
    [STATE_URL]: null,
    [STATE_URLS]: null,
    [STATE_TYPE]: 'DynForm',
    [STATE_SUBFORM]: false,
    [STATE_SUBFORM_TEMP_DATA]: null, */
  }
}

const getters = {
  popups: (state) => state[STATE_POPUPS],
  isOpened: (state) => {
    return lastPopup(state)[STATE_IS_OPENED]
  },
  getUrl: (state) => lastPopup(state)[STATE_URL],
  getUrls: (state) => lastPopup(state)[STATE_URLS],
  getType: (state) => lastPopup(state)[STATE_TYPE],
  getTitle: (state) => lastPopup(state)[STATE_TITLE],
  getSubForm: (state) => lastPopup(state)[STATE_SUBFORM],
  getSubFormTempData: (state) => lastPopup(state)[STATE_SUBFORM_TEMP_DATA],
  getCreateNewElement: (state) => lastPopup(state)[STATE_CREATE_NEW_ELEMENT],
  getRoutedUrl: (state) => state[STATE_ROUTED_URL],
  getEvent: (state) => lastPopup(state)[STATE_EVENT],
}

const actions = {
  popPopups({ commit, state }) {
    commit(MUTATION_POP_POPUPS, state)
  },
  setOpened({ commit, state }, opened = true) {
    commit(MUTATION_SET_OPENED, opened)
  },
  setUrl({ commit, state }, params) {
    commit(MUTATION_SET_URL, params)
  },
  setUrls({ commit, state }, urls) {
    commit(MUTATION_SET_URLS, urls)
  },
  setType({ commit, state }, type = 'DynForm') {
    commit(MUTATION_SET_TYPE, type)
  },
  setTitle({ commit, state }, title) {
    commit(MUTATION_SET_TITLE, title)
  },
  setSubForm({ commit, state }, subForm) {
    commit(MUTATION_SET_SUBFORM, subForm)
  },
  setSubFormTempData({ commit, state }, subFormData) {
    commit(MUTATION_SET_SUBFORM_TEMP_DATA, subFormData)
  },
  setCreateNewElement({ commit, state }, createNewElement) {
    commit(MUTATION_SET_CREATE_NEW_ELEMENT, createNewElement)
  },
  setRoutedUrl({ commit, state }, url) {
    commit(MUTATION_SET_ROUTED_URL, url)
  },
}
const mutations = {
  [MUTATION_POP_POPUPS](state) {
    state[STATE_POPUPS].pop()
  },
  [MUTATION_SET_OPENED](state, opened) {
    updatePopup(state, { [STATE_IS_OPENED]: opened })
  },
  [MUTATION_SET_URL](state, params) {
    let url = null
    let type = null
    let event = 'refresh-layout'
    if (params.url) {
      url = params.url
    } else if (params) {
      url = params
    }
    if (params.type) {
      type = params.type
    }

    if (params.event) {
      event = params.event
    }

    if (url) {
      const payload = {
        [STATE_URL]: url,
        [STATE_IS_OPENED]: false,
        [STATE_TYPE]: 'DynForm',
        [STATE_EVENT]: event,
      }

      if (lastPopup(state).urls) {
        updatePopup(state, { [STATE_URLS]: null })
        updatePopup(state, payload)
      } else if (type === 'saveAndNew') {
        updatePopup(state, { [STATE_URL]: url })
      } else {
        state[STATE_POPUPS].push(payload)
      }
    } else {
      state[STATE_POPUPS].pop()
    }
  },
  [MUTATION_SET_URLS](state, urls) {
    updatePopup(state, { [STATE_URLS]: urls })
  },
  [MUTATION_SET_TYPE](state, type) {
    updatePopup(state, { [STATE_TYPE]: type })
  },
  [MUTATION_SET_TITLE](state, title) {
    updatePopup(state, { [STATE_TITLE]: title })
  },
  [MUTATION_SET_SUBFORM](state, subForm) {
    updatePopup(state, { [STATE_SUBFORM]: subForm })
  },
  [MUTATION_SET_SUBFORM_TEMP_DATA](state, subFormData) {
    updatePopup(state, { [STATE_SUBFORM_TEMP_DATA]: subFormData })
  },
  [MUTATION_SET_CREATE_NEW_ELEMENT](state, createNewElement) {
    updatePopup(state, { [STATE_CREATE_NEW_ELEMENT]: createNewElement })
  },
  [MUTATION_SET_ROUTED_URL](state, url) {
    state[STATE_ROUTED_URL] = url
  },
}

export default bootstrap({
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
})
